/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  "aws_project_region": "us-east-1",
  "aws_cognito_identity_pool_id": "us-east-1:ed9145a1-6bf4-4b50-8dee-c0d7e969a26e",
  "aws_cognito_region": "us-east-1",
  "aws_user_pools_id": "us-east-1_8Qs3gDpzs",
  "aws_user_pools_web_client_id": "438qq8nutgi8k9hcvev2197b0n",
  "oauth": {
    "domain": "https://artifycuiqa-dev.auth.us-east-1.amazoncognito.com",
    "scope": [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin"
    ],
    "redirectSignIn": "https://qa.artistree.com/",
    "redirectSignOut": "https://qa.artistree.com/",
    "responseType": "code"
  },
  "federationTarget": "COGNITO_USER_POOLS",
};


export default awsmobile;
